var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.44 0 0 13.44 0 30C0 46.56 13.44 60 30 60C46.56 60 60 46.56 60 30C60 13.44 46.56 0 30 0Z",
    fill: "#BCA8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3818 21.25C31.7625 21.25 32.8818 20.1307 32.8818 18.75C32.8818 17.3693 31.7625 16.25 30.3818 16.25C29.0011 16.25 27.8818 17.3693 27.8818 18.75C27.8818 20.1307 29.0011 21.25 30.3818 21.25Z",
    fill: "#16161E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3809 43.75V25.625",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.e42fe077081c2c92059739754ea720ba.svg";
export { ForwardRef as ReactComponent };